<div [ngClass]="productImages.length && isImage ? 'cursor-pointer' : '' ">
    <img [src]="isLoading ? loader : image" align="left" class="mr-1" [ngStyle]="{height:height+'px',width:width+'px'}" (click)="preview()"
    />
</div>
    
